<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Print Invoice</h1>
                <div class="section-header-breadcumb button">
                    <div class="selectgroup w-100">
                        <label class="selectgroup-item">
                            <input type="checkbox" value="usd" v-model="enableUsd" class="selectgroup-input">
                            <span class="selectgroup-button">USD</span>
                        </label>
                        <label class="selectgroup-item">
                            <input type="checkbox" value="idr" v-model="enableIdr" class="selectgroup-input">
                            <span class="selectgroup-button">IDR</span>
                        </label>
                    </div> 
                </div>
            </div>
            <div class="section-body">
                <h2 class="section-title">Nomor Invoice : {{ tipe_transaksi }}</h2>
                <div id="printMe">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>PT. EFI | Nomor Invoice : # {{ transaksiDetail.detail.nomor_invoice }} </h4>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                        <table class="table" style="border:none;">
                                            <tbody>
                                                <tr>
                                                    <th style="width:20%;border:none;">
                                                        Supplier
                                                    </th>
                                                    <td style="border:none;">
                                                        {{ transaksiDetail.detail.display_name }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th style="border:none;">
                                                        Email  
                                                    </th>
                                                    <td style="border:none;">
                                                        {{ transaksiDetail.detail.email }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th style="border:none;">
                                                        Alamat Supplier  
                                                    </th>
                                                    <td style="border:none;">
                                                        ({{ transaksiDetail.detail.alamat }})
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    <div class="table-responsive">
                                        <table id="produk" class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>No. </th>
                                                    <th>Kode Produk</th>
                                                    <th>Produk</th>
                                                    <th>Kuantitas</th>
                                                    <th v-if="enableUsd">Harga Satuan (USD)</th>
                                                    <th v-if="enableIdr">Harga Satuan (IDR)</th>
                                                    <th v-if="enableUsd">Harga Total (USD)</th>
                                                    <th v-if="enableIdr">Harga Total (IDR)</th>
                                                    <!-- <th>Harga Satuan</th>
                                                    <th>Jumlah</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data,index) in transaksiDetail.produkList" v-bind:key="data.id_produk">
                                                <td>
                                                    {{ index+1 }}
                                                </td>
                                                <td>
                                                    {{ data.transaksi_kode_produk }}
                                                </td>
                                                <td>
                                                    {{ data.transaksi_nama_produk }}
                                                </td>
                                                <td>
                                                    {{ data.qty }} {{ data.nama_satuan }}
                                                </td>
                                                <td v-if="enableUsd">
                                                    $. {{ currencyFormat(data.harga_satuan) }}
                                                </td>
                                                <td v-if="enableUsd">
                                                    $. {{ currencyFormat(data.harga_total) }}
                                                </td>
                                                <td v-if="enableIdr">
                                                    Rp. {{ currencyFormat(data.harga_satuan_idr) }}
                                                </td>
                                                <td v-if="enableIdr">
                                                    Rp. {{ currencyFormat(data.harga_total_idr) }}
                                                </td>
                                            </tr>
                                            </tbody>
                                            <tr v-if="enableIdr || enableUsd">
                                                <td style="text-align:right" :colspan="table_cell - 2">
                                                    Sub Total
                                                </td>
                                                <td v-if="enableUsd != enableIdr">

                                                </td>
                                                <td v-if="enableUsd">
                                                    $. {{ currencyFormat(transaksiDetail.detail.subtotal) }}
                                                </td>
                                                <td v-if="enableIdr">
                                                    Rp. {{ currencyFormat(transaksiDetail.detail.subtotal_idr) }}
                                                </td>
                                            </tr>
                                            <tr v-if="enableIdr || enableUsd" v-for="(bl,ind) in transaksiDetail.biayaLain" :key="ind">
                                                <td style="text-align:right" :colspan="table_cell - 2">
                                                    {{ bl.nama_biaya }}
                                                </td>
                                                <td colspan="2" style="text-align:center">
                                                    {{ bl.jumlah_biaya }} {{ biayaIconCallback(bl.jenis_biaya) }}
                                                </td>
                                            </tr>
                                            <tr v-if="enableIdr || enableUsd">
                                                <td style="text-align:right" :colspan="table_cell - 2">
                                                    Grand Total
                                                </td>
                                                <td v-if="enableUsd != enableIdr">

                                                </td>
                                                <td v-if="enableUsd">
                                                    $. {{ currencyFormat(transaksiDetail.detail.grand_total) }}
                                                </td>
                                                <td v-if="enableIdr">
                                                    Rp. {{ currencyFormat(transaksiDetail.detail.grand_total_idr) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td :colspan="this.table_cell - 1" >
                                                    &nbsp;
                                                </td>
                                                <td style="text-align:center;padding-top:10%;">
                                                    Tertanda
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-danger">Kembali</button>
                    <button @click="printInvoice()" class="btn btn-success"> <i class="fas fa-file"></i> Print Invoice</button>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
    'https://use.fontawesome.com/releases/v5.7.2/css/all.css'
  ]
}

Vue.use(VueHtmlToPaper, options);

export default {
    data() {
        return {
            transaksiDetail : {
                detail : {
                    nomor_transaksi : '',
                }
            },
            id_transaksi : '',
            tipe_transaksi : '',
            jenis_transaksi : '',
            url : '',
            jenis_transaksi : 'pembelian',
            setPengiriman : false,
            setPenerimaan : false,
            tanggal_pengiriman: '',
            tanggal_terima: '',
            produkDiterima : [],
            enableUsd : true,
            enableIdr : true,
            table_cell : 0
        }
    },
    mounted() {
        this.id_transaksi = this.$route.params.id_transaksi;
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.post("Transaksi/getDetailPembayaran/"+this.id_transaksi).then(result => {
                if(result.data.code == '00') {
                    alert('failed get Detail')
                }
                else {
                    this.transaksiDetail = result.data.detail
                    this.tipe_transaksi = this.transaksiDetail.detail.jenis_transaksi+" #"+this.transaksiDetail.detail.nomor_invoice
                    // this.url = result.data.detail.detail.tipe_transaksi+"-"+this.jenis_transaksi
                }
                this.$root.is_loading = !this.$root.is_loading;
            }, error => {
                this.$root.is_loading = !this.$root.is_loading;
                console.log('gk ok')
                context.errors = errors;
            });
            this.table_cell = document.getElementById('produk').rows[0].cells.length
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        printInvoice: function() {
            this.$htmlToPaper('printMe', () => {
                console.log('Printing done or got cancelled!');
            });
        },
        goBack: function() {
            // var path = window.localStorage.getItem('last_route')
            this.$router.go(-1)
            // var $path = window.location.href.split('/');
            // this.isActive = this.$route.path;
        },
        biayaIconCallback: function(jenis) {
            if(jenis == 'percentage') {
                return '%'
            }else if(jenis == 'idr') {
                return 'IDR'
            }else if(jenis == 'usd') {
                return 'USD'
            }
        },
    },
    computed: {
        'subtotal' : function() {
            var subtotal = 0;
            if(this.transaksiDetail.detail.status_bayar == '1'){
                let that = this
                this.transaksiDetail.produkList.forEach(function(item,index){
                    subtotal = subtotal + (item.harga_total * that.transaksiDetail.detail.kurs_usd)
                    console.log(subtotal)
                })
            }
            return subtotal
        }
    },
    watch: {
        'enableUsd' : function () {
            this.$nextTick(function(){
                this.table_cell = document.getElementById('produk').rows[0].cells.length
            })
            
        },
        'enableIdr' : function () {
            this.$nextTick(function(){
                this.table_cell = document.getElementById('produk').rows[0].cells.length
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pembelian/PrintInvoice.vue